import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

// Checking if the token is null or not. If it's null or the user is not authenticated then protected routes will navigate to login page.
export const ProtectedRoutes = () => {
  const userToken = sessionStorage.getItem('user-token');
  return userToken ? <Outlet /> : <Navigate to="/login" />;
};
